import { Injectable, signal } from "@angular/core";
import { WORK_SHOP } from "@api/entry/add";
import { GROUP } from "@api/group/get";
import { SHOP_ACTIVE } from "@api/shop/get";

@Injectable({
    providedIn: 'root'
})
export class Resolver{
    group   = signal<GROUP|undefined>(undefined);
    shop    = signal<SHOP_ACTIVE|undefined>(undefined);
    work_shop   = signal<WORK_SHOP|undefined>(undefined);
}